import React, { FC, useState, useEffect, useContext } from 'react';

import { EnhancedInput } from '../Input';
import { Constants } from './enums';
import { FormContext } from '../FormContext';

export const Phone: FC<{}> = () => {
	const { validationRules, setFieldValue, t } = useContext(FormContext);
	const [value, setValue] = useState('');

	useEffect(() => {
		setFieldValue({ [Constants.name]: value });
	}, [value]);

	return (
		<EnhancedInput
			type='tel'
			id={Constants.id}
			name={Constants.name}
			label={t('phone')}
			value={value}
			validationRules={validationRules.PHONE}
			setValue={setValue}
		/>
	);
};
